<template>
  <div class="group-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "groupBase",
};
</script>
